import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { useRefreshRelatedData } from '@/hooks/useRefreshRelatedData';
import { showApiErrorToast } from '@/utils/errors';
import { removeInstitutes } from '../api/userInstituteMapping.api';
import type { RemoveInstitutesPayload } from '../types/userInstituteMapping.types';

export function useRemoveInstitutes(onSuccess?: () => void) {
  const refreshRelatedData = useRefreshRelatedData();

  return useMutation({
    mutationFn: (payload: RemoveInstitutesPayload) => removeInstitutes(payload),
    onSuccess: () => {
      void refreshRelatedData('instituteMapping');
      toast.success('Institute removed successfully');
      onSuccess?.();
    },
    onError: (error) => {
      showApiErrorToast(error, 'Failed to remove institute');
    },
  });
}
